import React from 'react';

import { AttractionsFirestoreResponse, RowRenderer } from '../../types';
import { Flex, TableActions } from '..';

export const renderRows: RowRenderer<AttractionsFirestoreResponse> = (
  item,
  columnKey,
  actions,
) => {
  const cellValue = item[columnKey as keyof AttractionsFirestoreResponse] ?? '-';

  switch (columnKey) {
    case 'title':
      return item.title.pl;
    case 'action':
      return (
        'action'
      );
    case 'actions':
      return (
        <Flex justifyContent="center" direction="row" gap="15px">
          <TableActions actions={actions} item={item} />
        </Flex>
      );
    default:
      return cellValue as React.ReactNode; // Ensuring valid ReactNode return
  }
};
